import { ChangeEvent, useState } from "react";

const useInput = (initialValue: string | number) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(""),
    bind: {
      value,
      onChange: (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
      }
    }
  };
};

export default useInput;